const ITEM_TYPE = "ITEM";
export const DELETE_CARD = 'DELETE_CARD';
export const MOVE_CARD = 'MOVE_CARD';
export default ITEM_TYPE;
